// Mock data for dashboard analytics
// This data will be used as a fallback until the backend API endpoint is implemented

export const getMockDashboardAnalytics = () => ({
    cellGrowth: [
        { month: 'Jan', cells: 5 },
        { month: 'Feb', cells: 7 },
        { month: 'Mar', cells: 8 },
        { month: 'Apr', cells: 9 },
        { month: 'May', cells: 10 },
        { month: 'Jun', cells: 11 },
        { month: 'Jul', cells: 12 },
        { month: 'Aug', cells: 14 },
        { month: 'Sep', cells: 15 },
        { month: 'Oct', cells: 16 },
        { month: 'Nov', cells: 17 },
        { month: 'Dec', cells: 18 }
    ],
    memberGrowth: [
        { month: 'Jan', members: 45 },
        { month: 'Feb', members: 52 },
        { month: 'Mar', members: 58 },
        { month: 'Apr', members: 65 },
        { month: 'May', members: 72 },
        { month: 'Jun', members: 78 },
        { month: 'Jul', members: 85 },
        { month: 'Aug', members: 95 },
        { month: 'Sep', members: 102 },
        { month: 'Oct', members: 110 },
        { month: 'Nov', members: 118 },
        { month: 'Dec', members: 125 }
    ],
    leaderGrowth: [
        { month: 'Jan', leaders: 5 },
        { month: 'Feb', leaders: 6 },
        { month: 'Mar', leaders: 7 },
        { month: 'Apr', leaders: 8 },
        { month: 'May', leaders: 9 },
        { month: 'Jun', leaders: 10 },
        { month: 'Jul', leaders: 11 },
        { month: 'Aug', leaders: 12 },
        { month: 'Sep', leaders: 13 },
        { month: 'Oct', leaders: 14 },
        { month: 'Nov', leaders: 15 },
        { month: 'Dec', leaders: 16 }
    ],
    attendanceTrends: [
        { week: 'Week 1', attendance: 85, totalMembers: 100 },
        { week: 'Week 2', attendance: 78, totalMembers: 100 },
        { week: 'Week 3', attendance: 92, totalMembers: 105 },
        { week: 'Week 4', attendance: 88, totalMembers: 105 },
        { week: 'Week 5', attendance: 95, totalMembers: 110 },
        { week: 'Week 6', attendance: 82, totalMembers: 110 },
        { week: 'Week 7', attendance: 90, totalMembers: 115 },
        { week: 'Week 8', attendance: 87, totalMembers: 115 }
    ]
});
